import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import Map from './shared/ui/Map';
import ProjectCard from './ProjectCard';
import Pagination from './Pagination';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import Select from './shared/forms/fieldTypes/Select';
import { CardCollectionContainer } from './shared/designElements/CardElements';
import { fromBreakpoint, breakpointSizes } from '@/styles/breakpoints';
import { colorPalette, fonts, CUBIC_TIMING, fadeIn } from '@/styles/styleGuide';
import getLinkFromPageObject from '@/services/getLinkFromPageObject';
var FILTER_ENABLED = false; // The design team has asked to hide the filter functionality for now. See https://jungleminds.atlassian.net/browse/BAMECW-1038 for more details

var choices = [{
  key: '',
  value: 'Toon alle'
}, {
  key: 'newBuild',
  value: 'Nieuwbouw'
}, {
  key: 'existingBuild',
  value: 'Bestaande bouw'
}];
var ProjectMapBlock = /*#__PURE__*/function (_Component) {
  function ProjectMapBlock() {
    var _this;
    _classCallCheck(this, ProjectMapBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProjectMapBlock, [].concat(args));
    _defineProperty(_this, "state", {
      markers: [],
      projects: {},
      filterBy: '',
      page: 0,
      totalPages: 0
    });
    _defineProperty(_this, "paginateItems", function (map, divisor) {
      return map.reduce(function (acc, curr, index) {
        var objectIndex = Math.floor(index / divisor);
        if (!acc[objectIndex]) {
          acc[objectIndex] = [];
        }
        acc[objectIndex] = acc[objectIndex].concat([curr]);
        return acc;
      }, {});
    });
    _defineProperty(_this, "handleFilterChange", function (e) {
      var filterBy = e.target.value;
      var filteredItems = _this.props.map.filter(function (project) {
        if (filterBy === '') {
          return project;
        }
        return project.isNewBuild === (filterBy === 'newBuild');
      });
      var projects = _this.paginateItems(filteredItems, 12);
      var totalPages = Number(Object.keys(projects).slice(-1)[0]) + 1;
      _this.setState({
        filterBy: filterBy,
        markers: filteredItems,
        page: 0,
        projects: projects,
        totalPages: totalPages
      });
    });
    _defineProperty(_this, "handlePageChange", function (page) {
      _this.setState({
        page: page - 1
      });
    });
    return _this;
  }
  _inherits(ProjectMapBlock, _Component);
  return _createClass(ProjectMapBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        map = _this$props.map,
        filter = _this$props.filter;
      var divisor = filter && filter.show ? 12 : 3;
      var projects = this.paginateItems(map, divisor);
      var totalPages = Number(Object.keys(projects).slice(-1)[0]) + 1;
      this.setState({
        markers: map,
        projects: projects,
        totalPages: totalPages
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        renderWidth = _this$props2.renderWidth,
        map = _this$props2.map,
        filter = _this$props2.filter,
        link = _this$props2.link;
      var _this$state = this.state,
        markers = _this$state.markers,
        projects = _this$state.projects,
        page = _this$state.page,
        totalPages = _this$state.totalPages;
      var filterEnabled = filter && filter.show;
      return __jsx(React.Fragment, null, process.env.NEXT_PUBLIC_MAPBOX_APIKEY && __jsx(MapContainer, {
        isSmall: renderWidth < breakpointSizes.md,
        "data-id": "components_ProjectMapBlock_MapContainer"
      }, FILTER_ENABLED && filterEnabled && __jsx(FilterContainer, {
        "data-id": "components_ProjectMapBlock_FilterContainer"
      }, __jsx(Filter, {
        "data-id": "components_ProjectMapBlock_Filter"
      }, __jsx(FilterTitle, {
        "data-id": "components_ProjectMapBlock_FilterTitle"
      }, "Filter projecten"), __jsx(FormContainer, {
        "data-id": "components_ProjectMapBlock_FormContainer"
      }, __jsx(Select, {
        name: "buildSelector",
        choices: choices,
        onChange: this.handleFilterChange,
        defaultValue: choices[0].value,
        required: true,
        "data-id": "components_ProjectMapBlock_Select"
      })))), __jsx(Map, {
        markers: filterEnabled ? markers : map,
        containerElement: __jsx("div", {
          style: {
            height: '536rem'
          },
          "data-id": "components_ProjectMapBlock_div"
        }),
        loadingElement: __jsx("div", {
          style: {
            height: "100%"
          },
          "data-id": "components_ProjectMapBlock_div_8"
        }),
        mapElement: __jsx("div", {
          style: {
            height: "100%"
          },
          "data-id": "components_ProjectMapBlock_div_9"
        }),
        "data-id": "components_ProjectMapBlock_Map"
      })), __jsx(ProjectsContainer, {
        filterEnabled: filterEnabled,
        "data-id": "components_ProjectMapBlock_ProjectsContainer"
      }, (projects[page] || []).map(function (item) {
        return __jsx(ProjectCard, {
          key: item.slug,
          image: item.image,
          isNewBuild: item.isNewBuild,
          title: item.title,
          description: item.description,
          slug: item.slug,
          "data-id": "components_ProjectMapBlock_ProjectCard"
        });
      })), filterEnabled && __jsx(PaginationWrapper, {
        "data-id": "components_ProjectMapBlock_PaginationWrapper"
      }, __jsx(Pagination, {
        totalPages: totalPages,
        currentPage: page,
        visiblePages: 2,
        goToPageValue: this.handlePageChange,
        isLoading: false,
        "data-id": "components_ProjectMapBlock_Pagination"
      })), link && !filter && __jsx(ButtonContainer, {
        "data-id": "components_ProjectMapBlock_ButtonContainer"
      }, __jsx(ButtonPrimary, {
        type: link.linkType === 'internal' ? 'internalLink' : 'externalLink',
        route: '/' + getLinkFromPageObject(link.url),
        label: link.label,
        buttonColor: colorPalette.blue,
        "data-id": "components_ProjectMapBlock_ButtonPrimary"
      })));
    }
  }]);
}(Component);
export default ProjectMapBlock;
var MapContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  margin-top: 30rem;\n  margin-bottom: 30rem;\n"])));
var FilterContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 0 30rem;\n  margin-top: -50rem;\n  margin-bottom: 60rem;\n  opacity: 0;\n  animation-delay: 0.9s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ", ";\n  animation-duration: 0.5s;\n  animation-name: ", ";\n\n  ", ";\n"])), CUBIC_TIMING, fadeIn, fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: -80rem;\n    margin-bottom: 50rem;\n  "]))));
var Filter = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 5;\n  max-width: 980rem;\n  box-sizing: border-box;\n  padding: 20rem;\n  width: 100%;\n  background: #fff;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 25rem;\n  "]))));
var FilterTitle = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  font-weight: bold;\n  color: ", ";\n  margin: 0 0 10rem 0;\n\n  ", ";\n"])), fonts.primary, colorPalette.beige, fromBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 18rem;\n  "]))));
var FormContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n\n  > div {\n    width: 100%;\n    max-width: 300rem;\n  }\n"])));
var ProjectsContainer = styled(CardCollectionContainer)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (props) {
  return props.filterEnabled ? '10rem' : '-60rem';
});
var ButtonContainer = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding-top: 10rem;\n  padding-bottom: 30rem;\n"])));
var PaginationWrapper = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin: 30rem 0;\n"])));